<template>
  <v-card width="100%" class="d-flex justify-center" tile>
    <v-carousel
      cycle
      interval="10000"
      hide-delimiters
      height="auto"
      :show-arrows="false"
    >
      <v-carousel-item
        v-for="(comunicado, i) in comunicados"
        :key="i"
        ref="container"
      >
        <v-sheet color="#E3F2FD">
          <v-row class="fill-height pa-0 ma-0" align="center" justify="center">
            <div class="px-4">{{ comunicado.mensaje }}</div>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </v-card>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      noticias: {},
      colors: [
        "green",
        "secondary",
        "yellow darken-4",
        "red lighten-2",
        "orange darken-1",
      ],
      cycle: true,
    };
  },
  computed: {
    ...mapState(["comunicados"]),
  },
  methods: {
    //
  },
  async mounted() {},
};
</script>
<style scoped lang="css">
.bottom-gradient {
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  );
}

.preview {
  display: -webkit-box;
  overflow: hidden;
  white-space: pre-line;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
